export default __webpack_public_path__ + "static/media/site.bc078de9.webmanifest";